<div class="backDrop" *ngIf="showSubject.asObservable() | async">
    <div class="modal-dialog modal-lg update-modal">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
            </div>
            <div class="modal-body">
                <div>
                    <dx-data-grid [dataSource]="linkInformation" [height]="420" [showBorders]="true"
                        (onRowUpdated)="updateSettingTemplateField($event)">

                        <dxo-editing mode="popup" [allowUpdating]="true">
                            <dxo-popup title="Edit link information" [showTitle]="true" [width]="700" [height]="525">
                            </dxo-popup>
                            <dxo-form>
                                <dxi-item itemType="group" [colCount]="1" [colSpan]="2">
                                    <dxi-item dataField="displayName"></dxi-item>
                                    <dxi-item dataField="shortDescription"></dxi-item>
                                    <dxi-item dataField="longDescription" editorType="dxHtmlEditor" [editorOptions]="{
                                        toolbar: {
                                          items: [  {name: 'undo'},
                                                    {name: 'redo'},
                                                    {name: 'seperator'},
                                                    {name: 'size'},
                                                    {name: 'font', acceptedValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']},
                                                    {name: 'size', acceptedValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'] },
                                                    {name: 'separator'},
                                                    {name: 'bold'},
                                                    {name: 'italic'},
                                                    {name: 'strike'},
                                                    {name: 'underline'},
                                                    {name: 'alignLeft'},
                                                    {name: 'alignCenter'},
                                                    {name: 'alignRight'},
                                                    {name: 'alignJustify'},
                                                    {name: 'orderedList'},
                                                    {name: 'bulletList'},
                                                    {name: 'header', acceptedValues: [false, 1, 2, 3, 4, 5]},
                                                    {name: 'color'},
                                                    {name: 'background'},
                                                    {name: 'separator'},
                                                    {name: 'link'},
                                                    {name: 'image'},
                                                    {name: 'clear'},
                                                    {name: 'codeBlock'},
                                                    {name: 'blockquote'},
                                                    {name: 'separator'}
                                                 ]
                                        } }">


                                </dxi-item>
                                    <dxi-item dataField="pricingInformation" editorType="dxHtmlEditor" [editorOptions]="{
                                        toolbar: {
                                          items: [  {name: 'undo'},
                                                    {name: 'redo'},
                                                    {name: 'seperator'},
                                                    {name: 'size'},
                                                    {name: 'font', acceptedValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']},
                                                    {name: 'size', acceptedValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'] },
                                                    {name: 'separator'},
                                                    {name: 'bold'},
                                                    {name: 'italic'},
                                                    {name: 'strike'},
                                                    {name: 'underline'},
                                                    {name: 'alignLeft'},
                                                    {name: 'alignCenter'},
                                                    {name: 'alignRight'},
                                                    {name: 'alignJustify'},
                                                    {name: 'orderedList'},
                                                    {name: 'bulletList'},
                                                    {name: 'header', acceptedValues: [false, 1, 2, 3, 4, 5]},
                                                    {name: 'color'},
                                                    {name: 'background'},
                                                    {name: 'separator'},
                                                    {name: 'link'},
                                                    {name: 'image'},
                                                    {name: 'clear'},
                                                    {name: 'codeBlock'},
                                                    {name: 'blockquote'},
                                                    {name: 'separator'}
                                                 ]
                                        } }">
                                </dxi-item>

                                <dxi-item dataField="allowedFrequency" editorType="dxNumberBox"></dxi-item>
                                </dxi-item>
                            </dxo-form>
                        </dxo-editing>

                        <dxo-sorting mode="none">
                        </dxo-sorting>
                        <!-- <dxo-editing mode="row" [allowUpdating]="true">
                        </dxo-editing> -->
                        <dxo-selection mode="none"></dxo-selection>
                        <dxo-row-dragging [onAdd]="onAdd" [allowReordering]="true" [onReorder]="onReorder">
                        </dxo-row-dragging>
                        <dxo-scrolling mode="virtual"></dxo-scrolling>

                        <dxi-column dataField="sortingIndex" dataType="number" [sortIndex]="0" sortOrder="asc"
                            [width]="70" [allowEditing]="false"></dxi-column>
                        <dxi-column dataField="displayName" dataType="string" [width]="300"></dxi-column>
                        <dxi-column dataField="shortDescription" dataType="string" [width]="300"></dxi-column>
                        <dxi-column dataField="longDescription" dataType="string" [width]="300"></dxi-column>
                        <dxi-column dataField="pricingInformation" dataType="string" [width]="300"></dxi-column>
                    </dx-data-grid>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" (click)="saveSortingIndex()">
                    Save sorting index
                </button>
                <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="cancel()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
